<template>
    <card 
    :title="$trans(section.name)"
    header_class="pt-4 pl-5 pb-3"
    body-class="pt-0"
    class="shadow-none border-0"> 

        <template #body>

            <div class="card-body pt-0 pb-0 px-5">

                <div class="row">

                    <form-row 
                    v-for="row in rows"
                    :key="'row-'+row.id" 
                    :row="row" /> 

                </div> <!-- /.row --> 

                <form-section 
                v-for="section in sections"
                :key="'section-'+section.id" 
                :section="section" />

            </div> <!-- /.card-body -->

        </template>

    </card>
</template>


<script>

    export default {

        props: {

            section: {
                type: Object,
                default: () => {}
            },

            sections: {
                type: Array,
                default: () => []
            },
            
            rows: {
                type: Array,
                default: () => []
            }
            
        }

    }

</script>